module.exports = __webpack_public_path__ + "static/media/s_31.258915ad.mp3";